export interface PublicCustomerAccount {
  id: number;
  name: string;
  email: string;
  email_verified_at?: string | null;
  email_verified?: boolean;
  is_active: boolean;
  whatsapp_phone: string;
  phone?: string | null;
  city?: string | null;
  address?: string | null;
}

// Aucune clé de session du personnel ne doit être lue ou supprimée par l'espace client.
export const PUBLIC_TOKEN_KEY = 'suite241.publicCustomerToken.v1';
export const PUBLIC_RETURN_KEY = 'suite241.publicReturn.v1';
export const PUBLIC_VERIFICATION_KEY = 'suite241.publicVerification.v1';
export const PUBLIC_CHECKOUT_DRAFT_KEY = 'suite241.publicCheckoutDraft.v1';

export function publicToken(): string {
  try { return localStorage.getItem(PUBLIC_TOKEN_KEY) || ''; } catch { return ''; }
}

export function savePublicToken(token: string): void {
  if (token) localStorage.setItem(PUBLIC_TOKEN_KEY, token);
  else localStorage.removeItem(PUBLIC_TOKEN_KEY);
}

export function publicEmailVerified(customer: PublicCustomerAccount | null): boolean {
  return Boolean(customer?.is_active && (customer.email_verified === true || customer.email_verified_at));
}

export function safePublicReturn(value: unknown): string {
  if (typeof value !== 'string' || !value.startsWith('/') || (value.includes('\\') || [...value].some((character) => character.charCodeAt(0) < 32))) return '/';
  try {
    const url = new URL(value, 'https://public.invalid');
    if (url.origin !== 'https://public.invalid') return '/';
    if (!/^\/(?:commande|boutiques|contact|produits\/[^/]+)?$/.test(url.pathname)) return '/';
    // Les paramètres sensibles reçus par email ne font jamais partie du retour au catalogue.
    const shopId = url.searchParams.get('shop_id');
    return url.pathname + (shopId && /^\d+$/.test(shopId) ? `?shop_id=${shopId}` : '');
  } catch { return '/'; }
}

export function rememberPublicReturn(value: unknown): string {
  const path = safePublicReturn(value);
  try { sessionStorage.setItem(PUBLIC_RETURN_KEY, path); } catch { /* La navigation fonctionne sans stockage persistant. */ }
  return path;
}

export function storedPublicReturn(): string {
  try { return safePublicReturn(sessionStorage.getItem(PUBLIC_RETURN_KEY)); } catch { return '/'; }
}

export function clearPublicCheckoutContext(): void {
  try {
    [PUBLIC_CHECKOUT_DRAFT_KEY, PUBLIC_VERIFICATION_KEY, PUBLIC_RETURN_KEY].forEach((key) => sessionStorage.removeItem(key));
  } catch { /* Le panier, indépendant du compte, reste disponible. */ }
}
